import React from "react";
import { Rate } from "antd";

const PerformanceSummary = ({
  ratings,
  overallRating,
  numberOfEvents,
  skillEntries
}) => {
  const hasRatings = Object.values(ratings || {}).some((ratingGroup) =>
    Object.values(ratingGroup || {}).some(
      (value) => value !== null && value !== undefined && value > 0
    )
  );

  const hasPerformanceData =
    hasRatings ||
    overallRating ||
    numberOfEvents ||
    skillEntries?.length > 0;

  return (
    <div className="bg-white border border-grayBorder rounded-lg p-5 sticky top-6 max-w-[750px]">
      <h3 className="font-semibold mb-3">
        Performance Overview
      </h3>

      {!hasPerformanceData ? (
        <div className="border border-grayBorder rounded-md p-4 text-center">
          <h4 className="font-semibold mb-2 text-left">
            No Performance Feedback Yet
          </h4>

          <p className="text-sm text-gray-500 text-left">
            Select an event and submit a performance review to begin tracking
            ratings and skill performance for this staff member.
          </p>
        </div>
      ) : (
        <>
          <div className="border border-grayBorder rounded-md p-4 mb-5">
            <div className="flex items-center gap-2">
              {overallRating && (
                <span className="text-3xl font-bold">
                  {overallRating}
                </span>
              )}

              <Rate
                allowHalf
                disabled
                value={overallRating}
              />
            </div>

            {numberOfEvents && (
              <p className="text-sm text-gray-500">
                Based on {numberOfEvents} reviews
              </p>
            )}
          </div>

          {!!skillEntries?.length && (
            <div>
              <h4 className="font-medium mb-3">
                Skill Performance Overview
              </h4>

              <div className="space-y-2">
                {skillEntries.map((skill) => (
                  <div
                    key={skill.label}
                    className="flex justify-between items-center border border-grayBorder rounded-md px-3 py-2 text-sm"
                  >
                    <span>{skill.label}</span>

                    <span className="font-medium">
                      {skill.value}
                      <span className="ml-1">
                        ({skill.count})
                      </span>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PerformanceSummary;